module.exports = __webpack_public_path__ + "img/12.7c20d8c2.png";